import script from "./InfoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoModal.vue?vue&type=script&setup=true&lang=ts"

import "./InfoModal.vue?vue&type=style&index=0&id=68fbeef0&scooped=true&lang=css"

const __exports__ = script;

export default __exports__